import React from "react";
import MainContainer from "../../components/container/MainContainer";
import Modal from "../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import AddCharItem from "./AddAccount";
import AddCategory from "./AddCategory";
import { openModal } from "../../features/modalSLice";
import TransactionGridContainer from "../../components/container/TransactionGridContainer";
import TransactionGridItem from "../../components/container/TransactionGridItem";
import { Blocks, ListPlus, Scroll } from "lucide-react";
import AddChartAccount from "./accounts/AddChartAccount";
import AddChartCategory from "./categories/AddChartCategory";

const Chart = () => {
  const dispatch = useDispatch();
  const modalContent = useSelector((state) => state.modal.content);

  const openAddAccountModal = (e) => {
    dispatch(openModal(<AddChartAccount />));
  };

  const openAddCategoryModal = (e) => {
    dispatch(openModal(<AddChartCategory />));
  };

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <h3 className="text-text-1/80">Chart of Account</h3>
      <div>
        <TransactionGridContainer title="Account">
          <TransactionGridItem
            component={Scroll}
            title="Accounts"
            link="/settings/accounts"
          />

          <TransactionGridItem
            component={Blocks}
            title="Add Account"
            action={openAddAccountModal}
          />
        </TransactionGridContainer>
        <TransactionGridContainer title="Account Categories">
          <TransactionGridItem
            component={Scroll}
            title="Acc. Categories"
            link="/settings/account-categories"
          />
          <TransactionGridItem
            component={ListPlus}
            action={openAddCategoryModal}
            title="Add Category"
          />
        </TransactionGridContainer>
        <form></form>
      </div>
    </MainContainer>
  );
};

export default Chart;
